import {useSelector} from "react-redux";
import {getUserUidSelector} from "../app/appSelectors";
import {useEffect} from "react";

type ILocalWindow = Window & typeof globalThis & {
    hj?: (command: 'identify', userId: number | null, attributes?: { [key: string]: string | number | null }) => void
}

function HotjarProvider() {
    const uid = useSelector(getUserUidSelector);

    useEffect(() => {
        const localWindow: ILocalWindow = window;
        if (typeof (localWindow.hj) === "function" && uid) {
            localWindow.hj('identify', uid, { uid });
        }
    }, [uid]);

    return null;
}

export default HotjarProvider;
